import zipcodeBaseValidator from './zipcode';

export default zipcodeBaseValidator;
